//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import { PipelineAction } from './types';

const DEFAULT_ICON_PATH = '/assets/icons/actions/generic-action.svg';

type PipelineActionsResponse =
  | PipelineAction[]
  | {
      httpActions?: PipelineAction[];
      pythonActions?: PipelineAction[];
    };

export function getResponsePipelineActions(data: PipelineActionsResponse): PipelineAction[] {
  // Handle new format with httpActions and pythonActions
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const httpActions = (data.httpActions || []).map((action) => ({
      ...action,
      actionType: 'http' as const,
      iconPath: action.iconPath || DEFAULT_ICON_PATH,
    }));
    const pythonActions = (data.pythonActions || []).map((action) => ({
      ...action,
      actionType: 'python' as const,
      iconPath: action.iconPath || DEFAULT_ICON_PATH,
    }));

    return [...httpActions, ...pythonActions];
  }

  // Handle legacy format (direct array)
  if (Array.isArray(data)) {
    return data.map((action) => ({
      ...action,
      iconPath: action.iconPath || DEFAULT_ICON_PATH,
    }));
  }

  return [];
}
